/**
 * Site Configuration
 * 
 * Centralized configuration for organization constants.
 * Dynamic values (email, phone, social links) are fetched from the API.
 * Only static values that never change are defined here.
 */

// Developer URL from environment variable
export const DEVELOPER_URL = import.meta.env.VITE_DEVELOPER_URL || 'https://www.samandari.dev/';

export const IBANGA_PROMO_URL =
  import.meta.env.VITE_IBANGA_PROMO_URL || 'https://ibanga.samandari.dev';

export const SITE_CONFIG = {
    // Organization Info
    organization: {
        name: 'Youth Impact Mission Burundi',
        shortName: 'YIM Burundi',
        tagline: 'Transforming communities through faith-based youth leadership',
    },

    // Static Location Info (rarely changes)
    location: {
        country: 'Burundi',
        city: 'Bujumbura',
    },

    // Business Hours
    hours: {
        weekdays: '8:00 AM - 5:00 PM',
        saturday: '9:00 AM - 1:00 PM',
        sunday: 'Closed',
    },

    // Default Phone Country Code (for phone inputs)
    defaultCountryCode: 'BI', // Burundi ISO code
} as const;

// Helper functions for generating links
export const getMailtoLink = (email: string) => `mailto:${email}`;
export const getTelLink = (phone: string) => `tel:${phone.replace(/\s/g, '')}`;
export const getWhatsAppLink = (phone: string) =>
    `https://wa.me/${phone.replace(/[^0-9+]/g, '').replace('+', '')}`;

// Export individual values for convenience
export const { organization, location, hours } = SITE_CONFIG;
